// extracted by mini-css-extract-plugin
export var statItem = "_hw-1";
export var statsRow = "_hw-0";